/** Utility to help pluralise words. Example: {{plural mentionCount 'mention' 'mentions'}} */
export default function(count, singular, options) {
    options = Object.assign({hash: {}}, options);
    if (count === 1) return singular;
    return options.hash.plural || (singular + 's');
}